import React, {useState, useEffect, useRef} from "react";
import { TextField, useMediaQuery, Checkbox, FormControlLabel, FormHelperText, Typography, Box, Container, Button, MenuItem, Table, TableCell, TableRow, TableFooter, TableHead, TableBody, FormGroup, Grid, Radio, RadioGroup, FormLabel, FormControl, Card, CardContent } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import PdfModalViewer from "./PdfModalViewer.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { intValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp10Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_10_name: "",
    user_10_department: "",
    user_10_phone: "",
    user_10_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    total_price: 0,
    move_in: "",
    move_in_detail: "",
    move_out: "",
    move_out_detail: "",
    internet: null,
    alfa_text: "",
    details: []
  });
  const [errors,setErrors] = useState({});

  const [checked ,setChecked] = useState(
    {
      pc: false,
    }
  )
  const isMobile = useMediaQuery("(max-width:710px)");

  console.log(checked)

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

  const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_10_name: mypageData.user_name || "",
        user_10_department: mypageData.department || "",
        user_10_phone: mypageData.phone_number || "",
        user_10_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_10_name: "",
        user_10_department: "",
        user_10_phone: "",
        user_10_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchO10InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO10, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o10submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o10Status = resStatus.data?.o10_status || "";
        const o10Data = resO10.data || {};
        const mypage = resMypage.data || {};

        if (o10Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_10_name: null,
            user_10_department: null,
            user_10_phone: null,
            user_10_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_email: null,
            invoice_address: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            total_price: null,
            move_in: null,
            move_in_detail: null,
            move_out: null,
            move_out_detail: null,
            internet: null,
            alfa_text: null,
            details: []
            });
        } else {
            if (Object.values(o10Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o10Data,
                details: o10Data.details || []
            }));
            if (
              o10Data.user_10_name === mypage.user_name &&
              o10Data.user_10_department === mypage.department &&
              o10Data.user_10_phone === mypage.phone_number &&
              o10Data.user_10_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            if (
                o10Data.invoice_company_name === mypage.company_name &&
                o10Data.invoice_user_name === mypage.user_name &&
                o10Data.invoice_email === mypage.email &&
                o10Data.invoice_address === mypage.address &&
                o10Data.invoice_tel === mypage.phone_number &&
                o10Data.invoice_zip === mypage.zip_code
            ) {
                setSameAsInvoice("same");
                setInvFieldsDisabled(true);
            } else {
                setInvFieldsDisabled(false);
            }
            const hasPc =
              !!(o10Data.move_in ||
              o10Data.move_in_detail ||
              o10Data.move_out ||
              o10Data.move_out_detail ||
              (Array.isArray(o10Data.details) && o10Data.details.length > 0));

            setChecked({
              pc: hasPc,
            });
            }
            
            setNotApply(false);
        }

        } catch (err) {
        console.error("O10初期データ取得エラー:", err);
        }
    };

    fetchO10InitialData();
    }, []);


  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_10_name: "",
            user_10_department: "",
            user_10_phone: "",
            user_10_tel: "",
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
            invoice_fax: "",
            total_price: null,
            move_in: null,
            move_in_detail: null,
            move_out: null,
            move_out_detail: null,
            internet: null,
            alfa_text: null,
            details: []
          });
      }
  };
  const handleCheckboxChange = (isPc) => {
    setChecked({ pc: isPc });

    setFormData((prev) => ({
      ...prev,
      pc_detail: "",
      pc_num: 0,
      software: "",
      // 搬入/搬出リセット
      move_in: "",
      move_in_detail: "",
      move_out: "",
      move_out_detail: "",
    }));
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };  
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [items, setItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items-o10");
                setItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

    const [ submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
      try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
          alert("exhibitorId が不正です");
          return;
        }

        const submitErrors = {};

        if (!notApply) {
          if (!formData.user_10_name?.trim()) submitErrors.user_10_name = "入力してください";
          if (!formData.user_10_phone?.trim()) submitErrors.user_10_phone = "入力してください";
          if (!formData.user_10_tel?.trim()) submitErrors.user_10_tel = "入力してください";
          if (!formData.invoice_company_name?.trim()) submitErrors.invoice_company_name = "入力してください";
          if (!formData.invoice_user_name?.trim()) submitErrors.invoice_user_name = "入力してください";
          if (!formData.invoice_email?.trim()) submitErrors.invoice_email = "入力してください";
          if (!formData.invoice_address?.trim()) submitErrors.invoice_address = "入力してください";
          if (!formData.invoice_zip?.trim()) submitErrors.invoice_zip = "入力してください";
          if (!formData.invoice_tel?.trim()) submitErrors.invoice_tel = "入力してください";

          if (checked.pc) {
            const allZero =
              !formData.details || formData.details.every((d) => !d.number || d.number === 0);
            if (allZero) {
              submitErrors.details = "いずれか1つは数量を入力してください";
            }

            if (formData.move_in === "true") {
              // 11/4 搬入
              if (!formData.move_in_detail || formData.move_in_detail.trim() === "") {
                submitErrors.move_in_detail = "搬入詳細を入力してください";
              }
            } else if (formData.move_in === "false") {
              // 事前納品
              const [datePart, infoPart] = formData.move_in_detail?.split(",納品先情報:") || [];
              const date = datePart?.replace("希望日時:", "").trim();
              const info = infoPart?.trim();
              if (!date) submitErrors.move_in_detail_date = "希望日時を入力してください";
              if (!info) submitErrors.move_in_detail_info = "納品先情報を入力してください";
            }

            if (formData.move_out === "true") {
              // 11/7 搬出
              if (!formData.move_out_detail || formData.move_out_detail.trim() === "") {
                submitErrors.move_out_detail = "搬出詳細を入力してください";
              }
            } else if (formData.move_out === "false") {
              // 事前回収
              const [datePart, infoPart] = formData.move_out_detail?.split(",回収先情報:") || [];
              const date = datePart?.replace("希望日時:", "").trim();
              const info = infoPart?.trim();
              if (!date) submitErrors.move_out_detail_date = "希望日時を入力してください";
              if (!info) submitErrors.move_out_detail_info = "回収先情報を入力してください";
            }
          }
        }

        const fieldDisplayNames = {
          user_10_name: "担当者名",
          user_10_department: "担当部署",
          user_10_phone: "担当者携帯",
          user_10_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          details: "数量",
          move_in_detail: "搬入詳細",
          move_in_detail_date: "搬入希望日時",
          move_in_detail_info: "納品先情報",
          move_out_detail: "搬出詳細",
          move_out_detail_date: "搬出希望日時",
          move_out_detail_info: "回収先情報",
        };

        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        // --- サニタイズ関数 ---
        const sanitizeFormData = (data) => {
          if (Array.isArray(data)) {
            return data.map(sanitizeFormData);
          } else if (typeof data === "object" && data !== null) {
            const newObj = {};
            for (const [key, value] of Object.entries(data)) {
              if (value === "") {
                newObj[key] = null;
              } else if (value === "true") {
                newObj[key] = true;
              } else if (value === "false") {
                newObj[key] = false;
              } else if (
                typeof value === "string" &&
                !isNaN(Number(value)) &&
                value.trim() !== "" &&
                // 電話・FAX・郵便番号系は string で保持
                !key.includes("phone") &&
                !key.includes("tel") &&
                !key.includes("fax") &&
                !key.includes("zip") &&
                key !== "item_id"   // 👈 追加
              ) {
                newObj[key] = Number(value);
              } else {
                newObj[key] = sanitizeFormData(value);
              }
            }
            return newObj;
          }
          return data;
        };

        // details から number: 0 を削除
        const cleanedDetails = formData.details?.filter((item) => item.number !== 0) || [];

        const cleanedFormData = sanitizeFormData({
          ...formData,
          details: cleanedDetails,
        });

        const payload = {
          exhibitor_id: exhibitorId,
          formData: cleanedFormData,
          notApply: notApply,
        };

        const res = await api.post("/api/submit-o10", payload);

        if (res.status === 200) {
          alert("保存成功");
        } else {
          alert("保存失敗");
        }
        setTimeout(() => {
          if (isModal) {
            setFormModalOpen(false);
          } else {
            if (user?.user_id === 0) {
              navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
            } else {
              navigate(`/mypage/${user?.mypage_id}`);
            }
          }
        }, 1000);
      } catch (err) {
        console.error(err);
        alert("エラー");
      }
    };

    const getMoveRadioValue = (value, defaultTime) => {
    if (value === defaultTime) return 'default';
    if (value?.startsWith('それ以外')) return 'other';
    return '';
    };

    // 'default' / 'other' を選択したときの値に変換
    const getMoveDetailValue = (selected, defaultTime) => {
    return selected === 'default' ? defaultTime : 'それ以外:';
    };

    const handleMoveChange = (key, value) => {
    setFormData((prev) => ({
        ...prev,
        [key]: value,
        [`${key}_detail`]: '',
    }));
    };

    useConfirmBackLogout(navigate);
    useNavigationHistory();
    const remarksRef = useRef(null);

  const [open , setOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  console.log(formData)
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="SDGs 子ども・ユースフェア2026 PCレンタル申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00101BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#00101bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">PC・ソフトレンタル申込</Typography>
        <Container sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_10_name" value={formData.user_10_name} disabled={fieldsDisabled} onChange={handleChange("user_10_name")} error={!!submitErrors.user_10_name} helperText={submitErrors.user_10_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_10_department" value={formData.user_10_department} disabled={fieldsDisabled} onChange={handleChange("user_10_department")} error={!!submitErrors.user_10_department} helperText={submitErrors.user_10_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_10_phone" value={formData.user_10_phone} disabled={fieldsDisabled} onChange={handleChange("user_10_phone")} error={!!submitErrors.user_10_phone} helperText={submitErrors.user_10_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_10_tel" value={formData.user_10_tel} disabled={fieldsDisabled} onChange={handleChange("user_10_tel")} error={!!submitErrors.user_10_tel} helperText={submitErrors.user_10_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                {user?.co_exhibit && sameAsInvoice === "different" && (
                  <Button
                    variant="outlined"
                    onClick={handleParentInvoiceClick}
                    disabled={loading}
                    style={{ marginBottom: "16px" }}
                  >
                    親出展者に請求する
                  </Button>
                )}
                </FormControl>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} /></Grid>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} /></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} /></Grid>
                    <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} /></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} /></Grid>
                    <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} /></Grid>
                    <Grid size={6}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                </Grid>
            </Box>   
            <Box>
                {/* <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>インターネット接続</Typography>
                <FormControl component="fieldset">
                <RadioGroup
                    row
                    value={formData.internet}
                    onChange={(e) => setFormData({ ...formData, internet: e.target.value === 'true' })}
                >
                    <FormControlLabel value="true" control={<Radio />} label="希望する" />
                    <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                </RadioGroup>

                {formData.internet && (
                    <Box sx={{ mt: 1 }}>
                    <Box sx={{display: 'flex'}}>
                      <img src="/internet_qr.png" alt="QRコード" style={{ width: 150 }} />
                      <Typography>＜申込みサイトURL＞<a href="https://entry.mice-net.jp/ex/593/reg" target="_blank">https://entry.mice-net.jp/ex/593/reg</a></Typography>
                    </Box>
                    <Typography variant="body2" color="textSecondary">
                        URLもしくはQRコードからお申し込みください
                    </Typography>
                    </Box>
                )}
                </FormControl> */}
                <Box>
                  {/* <FormControl
                    required
                    component="fieldset"
                    variant="standard"
                  >
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="pc"
                            checked={checked.pc === true}
                            onChange={() => handleCheckboxChange(true)}
                          />
                        }
                        label="PC・ソフトレンタルを希望する"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="nopc"
                            checked={checked.pc === false}
                            onChange={() => handleCheckboxChange(false)}
                          />
                        }
                        label="PC・ソフトレンタルを希望しない"
                      />
                    </FormGroup>
                  </FormControl> */}
                </Box>
                <Box>
                  {/* <Box>
                      <Button variant="outlined" onClick={() => setOpen(true)}>出展の手引き該当ページを確認する</Button>
                  </Box>
                  <PdfModalViewer
                      filePath="/SDGs 子ども・ユースフェア2025-出展の手引き.pdf"
                      isOpen={open}
                      onClose={() => setOpen(false)}
                      startPage={37}
                      endPage={38}
                  /> */}
                  <Box sx={{p: 3}}></Box>
                  {isMobile ? (
                    <>
                    {/* <Button
                      variant="contained"
                      onClick={() => {
                        remarksRef.current?.scrollIntoView({
                          behavior: "smooth",
                        });
                      }}
                      sx={{
                        position: "fixed",
                        bottom: 16,
                        right: 16,
                        zIndex: 1000,
                        borderRadius: "999px",
                      }}
                    >
                      商品搬入へ
                    </Button> */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      {items.map((item, index) => {
                        const detail = formData.details.find(d => d.item_id === item.item_id);
                        const number = detail?.number || 0;

                        // unit_price がない場合
                        const hasPrice = item.unit_price != null;
                        const unitTotal = hasPrice ? item.unit_price * number : null;
                        const showNotice = ["A","B","C"].includes(item.item_id);
                        const showContactNotice = ["E","F","4","10"].includes(item.item_id);

                        const handleValidatedNumberChange = (index) => (e) => {
                          const item = items[index];
                          if (item.unit_price == null) return;

                          const raw = e.target.value;

                          const { value, error } = intValidator({
                            label: "数量",
                          })(raw);

                          // 行単位エラー
                          setErrors((prev) => ({
                            ...prev,
                            [`details_${index}_number`]: error,
                          }));

                          if (value === null) return;

                          const newDetails = [...formData.details];
                          const existingIndex = newDetails.findIndex(
                            (d) => d.item_id === item.item_id
                          );

                          const normalized = value === "" ? "" : Number(value);

                          if (existingIndex !== -1) {
                            newDetails[existingIndex].number = normalized;
                          } else {
                            newDetails.push({
                              item_id: item.item_id,
                              number: normalized,
                            });
                          }

                          const newTotal = items.reduce((acc, it) => {
                            const detail = newDetails.find((d) => d.item_id === it.item_id);
                            const num = detail?.number || 0;
                            return acc + (it.unit_price || 0) * num;
                          }, 0);

                          setFormData({
                            ...formData,
                            details: newDetails,
                            total_price: newTotal,
                          });
                        };
  
                        return (
                          <Card key={item.item_id}>
                            <CardContent>
  
                              <Typography variant="caption" color="text.secondary">
                                品番
                              </Typography>
  
                              <Typography
                                sx={{
                                  fontFamily: "monospace",
                                  mb: 1,
                                }}
                              >
                                {item.item_id}
                              </Typography>
  
                              <Typography variant="caption" color="text.secondary">
                                品名
                              </Typography>
  
                              <Typography sx={{ mb: 1 }}>
                                {item.item_name}
                              </Typography>
                              {/* {showNotice && (
                                <Typography color="error" variant="body2">
                                  ※インストール費込み<br />
                                  ※MS Officeは「2024/2021/2019」のうち一つをインストールします。お申し込みの際は、バージョンの指定を備考欄に入力をしてください。
                                </Typography>
                              )}
                              {showContactNotice && (
                                <Typography color="error" variant="body2">
                                  ※備考欄よりお問い合わせください。
                                </Typography>
                              )} */}
  
                              <Typography variant="caption" color="text.secondary">
                                単価(税込)
                              </Typography>
  
                              <Typography sx={{ mb: 2 }}>
                                {hasPrice ? `¥${item.unit_price.toLocaleString()}` : "要問合せ"}
                              </Typography>
  
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                数量
                              </Typography>
  
                              <TextField
                                value={number}
                                onChange={handleValidatedNumberChange(index)}
                                size="small"
                                fullWidth
                                onWheel={(e) => e.target.blur()}
                                inputProps={{ min: 0 }}
                                disabled={!hasPrice}
                                error={!!errors[`details_${index}_number`]}
                                helperText={errors[`details_${index}_number`]}
                              />
  
                              <Typography variant="caption" color="text.secondary">
                                合計
                              </Typography>
  
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                }}
                              >
                                {hasPrice ? `¥${unitTotal.toLocaleString()}` : "要問合せ"}
                              </Typography>
                            </CardContent>
                          </Card>
                        );
                      })}
  
                      <Card>
                        <CardContent>
                          <Typography variant="subtitle2">
                            総合計金額
                          </Typography>
  
                          <Typography variant="h6">
                            ¥{(formData.total_price ?? 0).toLocaleString()}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Box>
                    </>
                  ) : (
                    <>
                    <Table size="small">
                      <TableHead>
                          <TableRow>
                          <TableCell>品番</TableCell>
                          <TableCell>品名</TableCell>
                          <TableCell sx={{width: '100px'}}>単価(税込)</TableCell>
                          <TableCell>数量</TableCell>
                          <TableCell sx={{width: '100px'}}>合計</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                        {items.map((item, index) => {
                          const detail = formData.details.find(d => d.item_id === item.item_id);
                          const number = detail?.number || 0;

                          // unit_price がない場合
                          const hasPrice = item.unit_price != null;
                          const unitTotal = hasPrice ? item.unit_price * number : null;
                          const showNotice = ["A","B","C"].includes(item.item_id);
                          const showContactNotice = ["E","F","4","10"].includes(item.item_id);

                          const handleValidatedNumberChange = (index) => (e) => {
                            const item = items[index];
                            if (item.unit_price == null) return;

                            const raw = e.target.value;

                            const { value, error } = intValidator({
                              label: "数量",
                            })(raw);

                            // 行単位エラー
                            setErrors((prev) => ({
                              ...prev,
                              [`details_${index}_number`]: error,
                            }));

                            if (value === null) return;

                            const newDetails = [...formData.details];
                            const existingIndex = newDetails.findIndex(
                              (d) => d.item_id === item.item_id
                            );

                            const normalized = value === "" ? "" : Number(value);

                            if (existingIndex !== -1) {
                              newDetails[existingIndex].number = normalized;
                            } else {
                              newDetails.push({
                                item_id: item.item_id,
                                number: normalized,
                              });
                            }

                            const newTotal = items.reduce((acc, it) => {
                              const detail = newDetails.find((d) => d.item_id === it.item_id);
                              const num = detail?.number || 0;
                              return acc + (it.unit_price || 0) * num;
                            }, 0);

                            setFormData({
                              ...formData,
                              details: newDetails,
                              total_price: newTotal,
                            });
                          };

                          return (
                            <React.Fragment key={item.item_id}>
                              <TableRow>
                                <TableCell>
                                  <Typography sx={{ fontFamily: "monospace" }}>{item.item_id}</Typography>
                                </TableCell>
                                <TableCell>
                                  {item.item_name}
                                  {/* {showNotice && (
                                    <Typography color="error" variant="body2">
                                      ※インストール費込み<br />
                                      ※MS Officeは「2024/2021/2019」のうち一つをインストールします。お申し込みの際は、バージョンの指定を備考欄に入力をしてください。
                                    </Typography>
                                  )}
                                  {showContactNotice && (
                                    <Typography color="error" variant="body2">
                                      ※備考欄よりお問い合わせください。
                                    </Typography>
                                  )} */}
                                </TableCell>
                                <TableCell>
                                  {hasPrice ? `¥${item.unit_price.toLocaleString()}` : "要問合せ"}
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    value={number}
                                    onChange={handleValidatedNumberChange(index)}
                                    size="small"
                                    fullWidth
                                    onWheel={(e) => e.target.blur()}
                                    inputProps={{ min: 0 }}
                                    disabled={!hasPrice}
                                    error={!!errors[`details_${index}_number`]}
                                    helperText={errors[`details_${index}_number`]}
                                  />
                                </TableCell>
                                <TableCell>
                                  {hasPrice ? `¥${unitTotal.toLocaleString()}` : "要問合せ"}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        })}
                      </TableBody>
                      <TableFooter>
                      <TableRow>
                          <TableCell colSpan={4} align="right">
                          <Typography variant="subtitle1">総合計金額:</Typography>
                          </TableCell>
                          <TableCell>
                          <Typography variant="subtitle1">
                              ¥{(formData.total_price ?? 0).toLocaleString()}
                          </Typography>
                          </TableCell>
                      </TableRow>
                      </TableFooter>
                    </Table>
                    </>
                  )}
                  <Typography color="error" variant="body2" sx={{mt: 1 , mb: 1}}>
                    上記レンタル料金は、会期中の特別料金（運送費込金額）です。開梱、設置、梱包作業は含みません。<br />
                    オプションとしてブース内ネットワーク配線、設定、機器開梱作業、解体撤去等を有償にて承ります。別途ご相談ください。<br />
                    上記以外にも、各社パソコン本体、周辺機器、ネットワーク機器など、多数取り揃えています。備考欄よりお問合せください。
                  </Typography>
                  {/* <Typography color="error" sx={{border: '1px solid #000', padding: 2}}>
                    ※名刺交換用iPhoneパッケージプランをお申し込みの方は、<Button sx={{color: '#0071BC'}} onClick={() => navigate('/form-o-8')}>こちら</Button>からお申し込み下さい。<br />
                    お問い合わせは、(株)中部経済新聞社にご連絡ください。
                  </Typography> */}
                </Box>
                {/* <Typography variant="h6" gutterBottom ref={remarksRef}>商品搬入</Typography>
                <FormControl component="fieldset" error={!!submitErrors.move_in}>
                  <FormLabel>商品搬入</FormLabel>
                  <RadioGroup
                    row
                    value={formData.move_in}
                    onChange={(e) => handleMoveChange("move_in", e.target.value === "true")}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="11月4日" />
                    <FormControlLabel value="false" control={<Radio />} label="事前納品" />
                    {submitErrors.move_in_detail && <FormHelperText sx={{color:"red"}}>{submitErrors.move_in_detail}</FormHelperText>}
                  </RadioGroup>
                  

                {formData.move_in ? (
                  // 11/4を選んだ場合
                  <Box sx={{ mt: 1 }}>
                    <RadioGroup
                      value={getMoveRadioValue(formData.move_in_detail, '10:00~12:00')}
                      onChange={(e) => {
                        const newValue = getMoveDetailValue(e.target.value, '10:00~12:00');
                        setFormData({ ...formData, move_in_detail: newValue });
                      }}
                    >
                      <FormControlLabel value="default" control={<Radio />} label="10:00～12:00" />
                      <FormControlLabel value="other" control={<Radio />} label="それ以外" />
                    </RadioGroup>

                    {formData.move_in_detail?.startsWith?.('それ以外') && (
                      <TextField
                        fullWidth
                        label="搬入希望時間"
                        value={formData.move_in_detail?.replace('それ以外:', '')}
                        onChange={(e) =>
                          setFormData({ ...formData, move_in_detail: `それ以外:${e.target.value}` })
                        }
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  </Box>
                ) : (
                  // 事前納品を選んだ場合
                  <Box sx={{ mt: 1 }}>
                    <TextField
                      fullWidth
                      label="希望日時"
                      sx={{ mb: 1 }}
                      value={formData.move_in_detail?.split(',納品先情報:')[0]?.replace('希望日時:', '') || ''}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          move_in_detail: `希望日時:${e.target.value},納品先情報:${formData.move_in_detail.split('納品先情報:')[1] || ''}`,
                        })
                      }
                      error={!!submitErrors.move_in_detail_date}
                      helperText={submitErrors.move_in_detail_date}
                    />

                    <TextField
                      fullWidth
                      label="納品先情報"
                      value={formData.move_in_detail?.split(',納品先情報:')[1] || ''}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          move_in_detail: `希望日時:${formData.move_in_detail.split(',納品先情報:')[0]?.replace('希望日時:', '') || ''},納品先情報:${e.target.value}`,
                        })
                      }
                      error={!!submitErrors.move_in_detail_info}
                      helperText={submitErrors.move_in_detail_info}
                      slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                    />
                  </Box>
                )}
                </FormControl> */}
                {/* <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>商品搬出</Typography>
                <FormControl component="fieldset" error={!!submitErrors.move_in}>
                <RadioGroup
                    row
                    value={formData.move_out}
                    onChange={(e) => handleMoveChange('move_out', e.target.value === 'true')}
                >
                    <FormControlLabel value="true" control={<Radio />} label="11月7日" />
                    <FormControlLabel value="false" control={<Radio />} label="事前回収" />
                    {submitErrors.move_out_detail && <FormHelperText sx={{color:"red"}}>{submitErrors.move_out_detail}</FormHelperText>}
                </RadioGroup>

                {formData.move_out ? (
                    <Box sx={{ mt: 1 }}>
                    <RadioGroup
                    value={getMoveRadioValue(formData.move_out_detail, '17:00~19:00')}
                    onChange={(e) => {
                        const newValue = getMoveDetailValue(e.target.value, '17:00~19:00');
                        setFormData({ ...formData, move_out_detail: newValue });
                    }}
                    >
                        <FormControlLabel value="default" control={<Radio />} label="17:00～19:00" />
                        <FormControlLabel value="other" control={<Radio />} label="それ以外" />
                    </RadioGroup>
                    {formData.move_out_detail.startsWith('それ以外') && (
                        <TextField
                            fullWidth
                            label="搬出希望時間"
                            value={formData.move_out_detail?.replace('それ以外:', '')}
                            onChange={(e) =>
                            setFormData({ ...formData, move_out_detail: `それ以外:${e.target.value}` })
                            }
                            InputLabelProps={{ shrink: true }}
                        />
                    )}
                    </Box>
                ) : (
                    <Box sx={{ mt: 1 }}>
                    <TextField
                        fullWidth
                        label="希望日時"
                        sx={{ mb: 1 }}
                        value={formData.move_out_detail?.split(',回収先情報:')[0]?.replace('希望日時:', '') || ''}
                        onChange={(e) =>
                        setFormData({
                            ...formData,
                            move_out_detail: `希望日時:${e.target.value},回収先情報:${formData.move_out_detail.split('回収先情報:')[1] || ''}`,
                        })
                        }
                        error={!!submitErrors.move_out_detail_date}
                        helperText={submitErrors.move_out_detail_date}
                        slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                    />
                    <TextField
                        fullWidth
                        label="回収先情報"
                        value={formData.move_out_detail?.split(',回収先情報:')[1] || ''}
                        onChange={(e) =>
                        setFormData({
                            ...formData,
                            move_out_detail: `希望日時:${formData.move_out_detail.split(',回収先情報:')[0].replace('希望日時:', '')},回収先情報:${e.target.value}`,
                        })
                        }
                        error={!!submitErrors.move_out_detail_info}
                        helperText={submitErrors.move_out_detail_info}
                        slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                    />
                    <Typography color="error">会社名・住所・担当者名等をご入力ください。</Typography>
                    </Box>
                )}
                </FormControl> */}
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※PC・ソフトレンタル申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            </>
            )}
        </Container>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            SDGs 子ども・ユースフェア2026企画運営室（中部経済新聞社 事業部内）<br />
            担当：中島、佐野<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button
          variant="contained"
          onClick={handleCorrection}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "darkred",
            },
          }}
        >
          再提出
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          完了
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp10Sub;